import React from "react";

import { IActionLessons } from "../../../../state";

import styles from "./ActionCard.module.scss";

export interface IActionCardProps {
  lesson: IActionLessons | null;
  setModalLesson: React.Dispatch<React.SetStateAction<IActionLessons | null>>;
  modalOpen?: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ActionCard: React.FC<IActionCardProps> = ({
  lesson,
  setModalLesson,
  setModalOpen,
}) => {
  // lesson.answer.contents[1]（行動宣言） が存在しない、または空の場合はレンダリングしない
  if (
    !lesson?.answer?.contents?.[1] ||
    lesson.answer.contents[1].content === ""
  ) {
    return null;
  }
  const isEmpty = lesson?.reflection_realization_reference === null;

  return (
    <div
      className={`${styles.wrapper} ${!isEmpty && styles.reflectionWrapper}`}
    >
      <div className={styles.titleWrapper}>
        <h2>{lesson?.title}</h2>
        <p>{lesson?.name}</p>
      </div>
      <p className={styles.description}>
        {lesson?.answer?.contents?.[1]?.content}
      </p>
      {isEmpty === false && (
        <div className={styles.reflectionWorkWrapper}>
          <h2>行動から生まれた気づき</h2>
          <p>{lesson?.reflection_realization_reference?.content}</p>
        </div>
      )}
      <div className={styles.buttonContainer}>
        {!isEmpty ? (
          <button
            className={styles.outlineBtn}
            onClick={() => {
              setModalOpen(true);
              setModalLesson(lesson);
            }}
          >
            修正する
          </button>
        ) : (
          <button
            onClick={() => {
              setModalOpen(true);
              setModalLesson(lesson);
            }}
          >
            行動結果を記録する
          </button>
        )}
      </div>
    </div>
  );
};

export default ActionCard;
